import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const sundayPollEditApi = createAsyncThunk(
    'auth/sundayPolls/edit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.patch(apiRoutes.sundayPollsAction(`poll-update/${data.id}`, 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const sundayPollEditSlice = createSlice({
    name: 'sundayPolls Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(sundayPollEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(sundayPollEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(sundayPollEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const sundayPollEditReducer = sundayPollEditSlice.reducer